import React, { Component } from 'react'
import moment from 'moment'
import nzhcn from 'nzh/cn'
import zhihuHybrid from 'zhihu-hybrid'
import Module from '~/components/Module'
import SVG from '~/components/SVG'
import TextToggle from '~/components/TextToggle'
import { isHybridable, universalOpenUrl, universalDispatch } from '~/utils'
import dynamicDetailIcon from '~/assets/icon-dynamic-detail.svg'
import inviteIcon from '~/assets/icon-invite.svg'
import writeIcon from '~/assets/icon-write.svg'
import styles from './index.css'

export default class Index extends Component {
  state = {
    isInviteSupported: false,
    isAnswerSupported: false,
  }

  componentWillMount() {
    const { dynamicInfo: { myAnswerToken } = {} } = this.props

    if (myAnswerToken) {
      zhihuHybrid.supportsAction('base/openURL').then(isSupported => {
        this.setState({ isAnswerSupported: !isHybridable || isSupported })
      })
    } else {
      zhihuHybrid.supportsAction('commercial/writeAnswer').then(isSupported => {
        this.setState({ isAnswerSupported: !isHybridable || isSupported })
      })
    }

    zhihuHybrid.supportsAction('commercial/askToAnswer').then(isSupported => {
      this.setState({ isInviteSupported: !isHybridable || isSupported })
    })
  }

  handleWriteAnswer = () => {
    const { dynamicInfo: { combineProductToken } } = this.props
    universalDispatch(() => {
      zhihuHybrid.dispatch('commercial/writeAnswer', {
        questionId: `${combineProductToken}`,
      })
    })
  }

  handleViewAnswer = () => {
    const { dynamicInfo: { combineProductToken, myAnswerToken } } = this.props
    universalOpenUrl(
      `https://www.zhihu.com/question/${combineProductToken}/answer/${myAnswerToken}`
    )
  }

  handleInviteAnswer = () => {
    const { dynamicInfo: { combineProductToken } } = this.props
    universalDispatch(() => {
      zhihuHybrid.dispatch('commercial/askToAnswer', {
        questionId: `${combineProductToken}`,
      })
    })
  }

  render() {
    const { dynamicInfo } = this.props
    if (!dynamicInfo.period) return <div />

    const { isInviteSupported, isAnswerSupported } = this.state
    const hasAnswered = Boolean(dynamicInfo.myAnswerToken)

    return (
      <Module
        header={
          <div className={styles.dynamicDetailsHeader}>
            <SVG src={dynamicDetailIcon} width={10} height={12} />
            {`第${nzhcn.encodeS(dynamicInfo.period)}期活动`}
          </div>
        }
      >
        <div className={styles.dynamicDetailsContent}>
          <TextToggle
            className={styles.title}
            content={dynamicInfo.title}
            minLength={80}
          />
          <div className={styles.subTitle}>
            <span>本期活动时间：</span>
            <span className={styles.activityDate}>
              {moment
                .unix(dynamicInfo.startTime / 1000)
                .format('YYYY年MM月DD日')}-{moment
                .unix(dynamicInfo.endTime / 1000)
                .format('YYYY年MM月DD日')}
            </span>
          </div>
          <TextToggle
            className={styles.content}
            content={dynamicInfo.content}
            minLength={120}
            toggleButtonText="问题描述"
          />
        </div>
        {(isInviteSupported || isAnswerSupported) &&
          !dynamicInfo.pinTopic && (
            <div className={styles.dynamicButtonGroup}>
              {isInviteSupported && (
                <div
                  className={styles.dynamicButton}
                  onClick={this.handleInviteAnswer}
                >
                  <SVG src={inviteIcon} width={16} height={16} />
                  <span>邀请回答</span>
                </div>
              )}
              {isInviteSupported &&
                isAnswerSupported && (
                  <div className={styles.splitLineVertical} />
                )}
              {isAnswerSupported && (
                <div
                  className={styles.dynamicButton}
                  onClick={
                    hasAnswered ? this.handleViewAnswer : this.handleWriteAnswer
                  }
                >
                  <SVG src={!hasAnswered && writeIcon} width={16} height={16} />
                  <span>{hasAnswered ? '查看回答' : '添加回答'}</span>
                </div>
              )}
            </div>
          )}
      </Module>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/DynamicDetails/index.js